<script setup lang="ts">
import type { NuxtError } from '#app'
import { ROUTES } from '~/utils/constants'

const props = defineProps<{
  error: NuxtError
}>()

const handleError = () => clearError({ redirect: ROUTES.HOME })
</script>

<template>
  <div
    class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 p-6 font-sans"
  >
    <div
      class="max-w-md w-full bg-white dark:bg-gray-900 rounded-3xl p-10 shadow-2xl border border-gray-100 dark:border-gray-800 text-center animate-in fade-in zoom-in duration-500"
    >
      <div
        class="w-20 h-20 bg-primary-100 dark:bg-primary-900/30 rounded-2xl flex items-center justify-center mx-auto mb-8"
      >
        <UIcon
          name="i-heroicons-exclamation-triangle"
          class="w-10 h-10 text-primary-600 dark:text-primary-400"
        />
      </div>

      <h1 class="text-4xl font-black text-gray-900 dark:text-white mb-4 tracking-tight">
        {{ error.status === 404 ? 'Page Not Found' : 'Oops! Something went wrong' }}
      </h1>

      <p class="text-gray-500 dark:text-gray-400 mb-8 leading-relaxed">
        {{
          error.message ||
          "We encountered an unexpected error while processing your request. Don't worry, our team has been notified."
        }}
      </p>

      <div class="space-y-4">
        <UButton
          @click="handleError"
          size="xl"
          color="primary"
          class="w-full font-bold shadow-lg shadow-primary-500/20"
          icon="i-heroicons-home"
        >
          Back to Home
        </UButton>
      </div>

      <div
        v-if="error.status !== 404"
        class="mt-10 pt-8 border-t border-gray-100 dark:border-gray-800"
      >
        <p class="text-[10px] text-gray-400 uppercase font-black tracking-widest mb-2">
          Error Details
        </p>
        <code
          class="text-[10px] bg-gray-50 dark:bg-gray-800/50 p-2 rounded block break-all text-left text-gray-500 dark:text-gray-400"
        >
          {{ error.statusText || error.message }}
        </code>
      </div>
    </div>
  </div>
</template>
